import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GeneralConfirmComponent } from './general-confirm.component';

import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
    declarations: [
        GeneralConfirmComponent,
    ],
    imports: [
        CommonModule,
        MatButtonModule,
        MatDialogModule,
    ],
    exports: [
        GeneralConfirmComponent,
    ]
})
export class GeneralConfirmModule { }
